import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { sections, getCurrentSection } from '@/config/navigation';
import { useDropdown } from '@/hooks/useDropdown';

export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const currentSection = getCurrentSection(location.pathname);

  // Use the dropdown hook for proper event cleanup
  const menuRef = useDropdown({
    isOpen,
    onClose: () => setIsOpen(false),
  });

  // Close menu when navigating
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const Icon = currentSection.icon;

  return (
    <div ref={menuRef} className="relative">
      {/* Trigger button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label="Navigate sections"
        className="
          flex items-center gap-2 rounded-md px-3 py-1.5
          text-foreground hover:bg-background-hover
          transition-colors
        "
      >
        <Icon className="h-4 w-4" aria-hidden="true" />
        <span className="text-sm font-medium">{currentSection.label}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div
          role="menu"
          className="
            absolute left-0 top-full mt-1 w-48 rounded-md border border-border
            bg-background-elevated shadow-lg z-50
          "
        >
          <div className="py-1">
            {sections.map((section) => {
              const SectionIcon = section.icon;
              const isActive = section.id === currentSection.id;

              return (
                <Link
                  key={section.id}
                  to={section.subNav[0]?.path ?? section.basePath}
                  role="menuitem"
                  className={`
                    flex items-center gap-2 px-4 py-2 text-sm
                    transition-colors
                    ${isActive
                      ? 'bg-primary/10 text-primary font-medium'
                      : 'text-foreground-muted hover:bg-background-hover hover:text-foreground'
                    }
                  `}
                >
                  <SectionIcon className="h-4 w-4" aria-hidden="true" />
                  {section.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
